import React from 'react';
import PropTypes from 'prop-types';
import { Editor as TinyMCE } from '@tinymce/tinymce-react';

import tinymce from 'tinymce/tinymce';

import 'tinymce/themes/modern/theme';
import 'tinymce/skins/lightgray/skin.min.css';
// Any plugins you want to use has to be imported
import 'tinymce/plugins/media';
import 'tinymce/plugins/image';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';

import { uploadToS3 } from '../../client/addUploadCapability';

// react-tinymce use global ref
window.tinymce = tinymce;

const images_upload_handler = (blobInfo, success, failure) => { // eslint-disable-line
  console.log('blobinfo', blobInfo.blob());
  const file = blobInfo.blob();
  const image = {
    file,
    key: 'uploads',
  };

  uploadToS3(image, file.name, 'richtext')
    .then((res) => success(res.imageUrl))
    .catch((e) => { console.log('tinyMCE image upload failure', e); failure(`tinyMCE image upload failure - ${e}`); });
};

const TinyMCEInput = ({
  id,
  input: {
    value,
    onChange,
  },
  options: {
    config,
    basic = false,
    toolbar = '',
  } = {},
}) => (
  <TinyMCE
    id={id}
    value={value}
    init={basic ? {
      skin: false,
      theme: 'modern',
      toolbar: false,
      menubar: false,
      branding: false,
    } : {
      skin: false,
      theme: 'modern',
      menubar: 'file edit insert',
      plugins: 'image media paste lists link code',
      paste_as_text: true,
      height: 400,
      toolbar,
      images_upload_handler,
      branding: false,
      ...config,
    }}
    onEditorChange={(content) => {
      onChange(content);
    }}
  />
);


TinyMCEInput.propTypes = {
  input: PropTypes.object,
  options: PropTypes.object,
};

TinyMCEInput.defaultProps = {
  addField: true, // eslint-disable-line
  addLabel: true, // eslint-disable-line
};

export default TinyMCEInput;
